import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/takeoff-projects-v2/src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IMegaMenu, IMouGallery } from '../../store/shared.state';
declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  empty: any;
  api = environment.config.api;
  newApi = environment.config.newApi;
  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) {
    this.headers = this.headers.set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
  }

  fetch_seo_meta(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.api}seo-meta`, payload, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  fetch_seo_list(payload): Observable<any> {
    return this.http
      .post<any>(`${this.api}seo-list`, payload, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  fetch_mega_menu(): Observable<IMegaMenu> {
    return this.http
      .get<IMegaMenu>(`${this.api}custom-menu`, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  fetch_mou_gallery(payload: any): Observable<IMouGallery[]> {
    return this.http
      .post<IMouGallery[]>(`${this.api}mou-gallery`, payload, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }

  fetch_seo_filtered_projects(payload: any) {
    return this.http
      .post(`${this.api}seo-lists`, payload, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  fetch_seo_filtered_project(payload: any) {
    return this.http
      .post(`${this.api}seo-abstract`, payload, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  fetch_seo_other_pages() {
    return this.http
      .post<any>(`${this.api}seo-other-website`, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  emitEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null
  ) {
    gtag('send', 'event', {
      eventCategory,
      eventLabel,
      eventAction,
      eventValue
    });
  }

  reSubmitOtp(payload: any, formType: any) {
    return this.http
      .post<any>(`${this.api}${formType}`, payload, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  // submitOtp(payload: any, otpForm: any) {
  //   return this.http
  //     .post<any>(`${this.api}${otpForm}`, payload, { headers: this.headers })
  //     .pipe(catchError(this.handleError));
  // }

  async submitOtp(payload: any, otpForm: any): Promise<any> {
    try {
      const resonse = await fetch(`${this.api}${otpForm}`, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      return await resonse.json();
    } catch (error) {
      return this.handleError(error);
    }
  }

  async newSubmitOtp(
    payload: any,
    otpForm: any,
    isFormData = false,
    newFormType = 'forms'
  ): Promise<any> {
    try {
      const headers = {};

      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      const response = await fetch(
        `${this.newApi}${newFormType}/${otpForm}/otp-verify`,
        {
          method: 'POST',
          body: isFormData ? payload : JSON.stringify(payload),
          headers
        }
      );

      return await response.json();
    } catch (error) {
      return this.handleError(error);
    }
  }

  async resendOtp(payload: any, otpForm: any, isFormData = false) {
    try {
      const headers = {};

      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      const response = await fetch(`${this.newApi}forms/${otpForm}`, {
        method: 'POST',
        body: isFormData ? payload : JSON.stringify(payload),
        headers
      });

      return await response.json();
    } catch (error) {
      return this.handleError(error);
    }
  }

  handleError(error) {
    console.log(
      'Something went wrong, Please contact us',
      `Error_details: "${error}"`
    );
    return throwError(error);
  }

  // Common Methods for Quick Links Side Bar & Top Nav Bar - START

  createQuickLinks(
    selectedMenuType,
    mega_menu_data,
    department_id,
    seo_data?: any
  ): any {
    let selectedMenu =
      selectedMenuType.toLowerCase() == 'pg'
        ? mega_menu_data.pg
        : selectedMenuType.toLowerCase() == 'ug'
        ? mega_menu_data.ug
        : selectedMenuType.toLowerCase() == 'inter-diploma'
        ? mega_menu_data.inter
        : mega_menu_data.school;
    switch (selectedMenuType.toLowerCase()) {
      case 'ug':
        return mega_menu_data
          ? [
              ...new Map(
                selectedMenu
                  .filter(
                    f =>
                      f.dept_id == department_id &&
                      f.domain_id != 0 &&
                      f.oid == seo_data.oid
                  )
                  .map(j => [j.domain_id, j])
              ).values()
            ].map((d: any) => ({
              dept_id: d.dept_id,
              main_id: d.mid,
              domain_id: d.domain_id,
              domain_name: d.domain_name,
              oid: d.oid,
              third_menu: [
                ...new Map(
                  selectedMenu
                    .filter(
                      f =>
                        f.domain_id == d.domain_id &&
                        f.tech_id != 0 &&
                        f.oid == seo_data.oid
                    )
                    .map(jj => [jj.tech_id, jj])
                ).values()
              ].map((ff: any) => ({
                dept_id: ff.dept_id,
                main_id: ff.mid,
                domain_id: ff.domain_id,
                tech_id: ff.tech_id,
                tech_name: ff.tech_name,
                oid: ff.oid
              }))
            }))
          : [];

      default:
        return mega_menu_data
          ? [
              ...new Map(
                selectedMenu
                  .filter(f => f.dept_id == department_id && f.domain_id != 0)
                  .map(j => [j.domain_id, j])
              ).values()
            ].map((d: any) => ({
              dept_id: d.dept_id,
              main_id: d.mid,
              domain_id: d.domain_id,
              domain_name: d.domain_name,
              third_menu: [
                ...new Map(
                  selectedMenu
                    .filter(f => f.domain_id == d.domain_id && f.tech_id != 0)
                    .map(jj => [jj.tech_id, jj])
                ).values()
              ].map((ff: any) => ({
                dept_id: d.dept_id,
                main_id: d.mid,
                domain_id: d.domain_id,
                tech_id: ff.tech_id,
                tech_name: ff.tech_name
              }))
            }))
          : [];
    }
  }

  createTopNav(selectedMenuType, mega_menu_data) {
    if (selectedMenuType && mega_menu_data) {
      let selectedMenu =
        selectedMenuType.toLowerCase() == 'pg'
          ? mega_menu_data.pg
          : selectedMenuType.toLowerCase() == 'ug'
          ? mega_menu_data.ug
          : selectedMenuType.toLowerCase() == 'inter-diploma'
          ? mega_menu_data.inter
          : mega_menu_data.school;

      switch (selectedMenuType.toLowerCase()) {
        case 'ug':
          return mega_menu_data
            ? [...new Map(selectedMenu.map(d => [d.dept_id, d])).values()].map(
                (su: any) => ({
                  su_id: su.dept_id,
                  su_name: su.dept_name,
                  menu_options: {
                    dept_id: su.dept_id,
                    oid: su.oid
                  },
                  main_menu: [
                    ...[
                      ...new Map(
                        selectedMenu
                          .filter(f => f.dept_id == su.dept_id)
                          .map(j => [j.oid, j])
                      ).values()
                    ]
                      .filter((ff: any) => ff.oid != 0)
                      .map((og: any) => ({
                        main_id: og.oid,
                        main_name: og.organ_name,
                        menu_options: {
                          dept_id: og.dept_id,
                          mid: og.mid,
                          oid: og.oid
                        },
                        second_menu: [
                          ...new Map(
                            selectedMenu
                              .filter(
                                f =>
                                  f.dept_id == su.dept_id &&
                                  f.oid != 0 &&
                                  f.oid == og.oid &&
                                  f.domain_id != 0
                              )
                              .map(j => [j.domain_id, j])
                          ).values()
                        ].map((s: any) => ({
                          second_id: s.domain_id,
                          second_name: s.domain_name,
                          menu_options: {
                            dept_id: s.dept_id,
                            mid: s.mid,
                            sid: s.domain_id,
                            oid: s.oid
                          },
                          third_menu: [
                            ...new Map(
                              selectedMenu
                                .filter(
                                  f =>
                                    f.oid != 0 &&
                                    f.oid == og.oid &&
                                    f.domain_id == s.domain_id &&
                                    f.tech_id != 0
                                )
                                .map(ff => [ff.tech_id, ff])
                            ).values()
                          ].map((t: any) => ({
                            third_id: t.tech_id,
                            third_name: t.tech_name,
                            menu_options: {
                              dept_id: t.dept_id,
                              mid: t.mid,
                              sid: t.domain_id,
                              ssid: t.tech_id,
                              oid: t.oid
                            }
                          }))
                        }))
                      })),
                    ...[
                      ...new Map(
                        selectedMenu
                          .filter(f => f.dept_id == su.dept_id)
                          .map(j => [j.oid, j])
                      ).values()
                    ]
                      .filter((ff: any) => ff.oid == 0 && ff.mid != 0)
                      .map((og: any) => ({
                        main_id: og.mid,
                        main_name: og.menu_name,
                        menu_options: {
                          dept_id: og.dept_id,
                          mid: og.mid,
                          oid: og.oid
                        },
                        second_menu: [
                          ...new Map(
                            selectedMenu
                              .filter(
                                f =>
                                  f.dept_id == su.dept_id &&
                                  f.oid == 0 &&
                                  f.domain_id != 0
                              )
                              .map(j => [j.domain_id, j])
                          ).values()
                        ].map((s: any) => ({
                          second_id: s.domain_id,
                          second_name: s.domain_name,
                          menu_options: {
                            dept_id: s.dept_id,
                            mid: s.mid,
                            sid: s.domain_id,
                            oid: s.oid
                          },
                          third_menu: [
                            ...new Map(
                              selectedMenu
                                .filter(
                                  f =>
                                    f.oid == 0 &&
                                    f.domain_id == s.domain_id &&
                                    f.tech_id != 0
                                )
                                .map(ff => [ff.tech_id, ff])
                            ).values()
                          ].map((t: any) => ({
                            third_id: t.tech_id,
                            third_name: t.tech_name,
                            menu_options: {
                              dept_id: t.dept_id,
                              mid: t.mid,
                              sid: t.domain_id,
                              ssid: t.tech_id,
                              oid: t.oid
                            }
                          }))
                        }))
                      }))
                  ]
                })
              )
            : [];

        case 'school':
          return mega_menu_data
            ? [...new Map(selectedMenu.map(d => [d.mid, d])).values()].map(
                (su: any) => ({
                  su_id: su.mid,
                  su_name: su.menu_name,
                  menu_options: {
                    mid: su.mid
                  },
                  main_menu: [
                    ...new Map(
                      selectedMenu
                        .filter(f => f.dept_id == su.dept_id && f.mid == su.mid)
                        .map(ff => [ff.domain_id, ff])
                    ).values()
                  ].map((m: any) => ({
                    main_id: m.domain_id,
                    main_name: m.domain_name,
                    menu_options: {
                      dept_id: m.dept_id,
                      mid: m.mid,
                      sid: m.domain_id
                    },
                    second_menu: []
                  }))
                })
              )
            : [];

        default:
          return mega_menu_data
            ? [...new Map(selectedMenu.map(d => [d.dept_id, d])).values()].map(
                (su: any) => ({
                  su_id: su.dept_id,
                  su_name: su.dept_name,
                  menu_options: {
                    dept_id: su.dept_id,
                    mid: su.mid
                  },
                  main_menu: [
                    ...new Map(
                      selectedMenu
                        .filter(
                          f => f.dept_id == su.dept_id && f.domain_id != 0
                        )
                        .map(j => [j.domain_id, j])
                    ).values()
                  ].map((m: any) => ({
                    main_id: m.domain_id,
                    main_name: m.domain_name,
                    menu_options: {
                      dept_id: m.dept_id,
                      mid: m.mid,
                      sid: m.domain_id
                    },
                    second_menu: [
                      ...new Map(
                        selectedMenu
                          .filter(
                            f => f.domain_id == m.domain_id && f.tech_id != 0
                          )
                          .map(t => [t.tech_id, t])
                      ).values()
                    ].map((t: any) => ({
                      second_id: t.tech_id,
                      second_name: t.tech_name,
                      menu_options: {
                        dept_id: t.dept_id,
                        mid: t.mid,
                        sid: t.domain_id,
                        ssid: t.tech_id
                      }
                    }))
                  }))
                })
              )
            : [];
      }
    }
  }

  // fetch Faqs based on the url
   fetch_faqs(payload: any): Observable<any> {
    return this.http
      .get<any>(`${this.newApi}website/faqs-by-seo-url/${payload.seo_url}`, { headers: this.headers, params: payload })
      .pipe(catchError(this.handleError));
  }

}
